import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import plus from '../../../../../assets/images/icons/plus.svg';
import plusLight from '../../../../../assets/images/icons/plus-light.svg';
import minus from '../../../../../assets/images/icons/minus.svg';
import minusLight from '../../../../../assets/images/icons/minus-light.svg';

export const useStyles = makeStyles(({
  palette,
  fontFamilies,
  fontWeights,
  breakpoints,
}: Theme) => ({
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    borderTop: `2px solid ${palette.primary.dark}`,
  },
  listItem: {
    borderBottom: `2px solid ${palette.primary.dark}`,
  },
  button: {
    width: '100%',
    padding: '3rem 3.5rem 3rem 0',
    border: 'none',
    backgroundColor: 'transparent',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${plus})`,
    backgroundPositionX: 'calc(100% - 1.5rem)',
    backgroundPositionY: 'center',
    fontFamily: fontFamilies.primary,
    fontWeight: fontWeights.regular,
    fontSize: '1.25rem',
    lineHeight: 1.3,
    textAlign: 'left',
    [breakpoints.down('md')]: {
      fontSize: '1.75rem',
    },
    '&:hover': {
      paddingLeft: '1.5rem',
      color: palette.primary.light,
      backgroundColor: palette.primary.dark,
      backgroundImage: `url(${plusLight})`,
    },
    '&:focus': {
      outline: `2px dashed ${palette.primary.dark}`,
      outlineOffset: '-0.25rem',
    },
    '&.expanded': {
      backgroundImage: `url(${minus})`,
      '&:hover': {
        backgroundImage: `url(${minusLight})`,
      },
    },
  },
  panel: {
    display: 'none',
    paddingBottom: '3rem',
    fontFamily: fontFamilies.primary,
    fontWeight: fontWeights.regular,
    '&.expanded': {
      display: 'block',
    },
  },
}));
